export class SlideInfoModel{
  currentSlideNumber: number;
  totalSlideCount: number;
}